/* eslint-disable no-param-reassign */
/* eslint-disable no-useless-return */
/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash'
import { useStaticQuery, graphql } from 'gatsby'
import {
  useMetaDefinitions,
  useStores,
} from '../../vendor/react-omnitech-api'
import env from '../../config/env'
import moment from '../../helpers/moment'
import useCurrentOrderingPeriod from '../use-current-ordering-period'
// import { useCart } from '../use-cart'
import { useCommerceChannel } from '../use-commerce-channel'
import { useOrderMethod } from '../use-order-method'
import useOrderingPeriod from '../use-ordering-period'

export default function useSku(props = {}) {
  const {
    cart,
    orderMethodMandatory = true,
  } = props
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            commerceChannelPublicConfigSchemaVersion
          }
        }
      }
    `,
  )
  const {
    getCurrentSlotCodes,
    // getCurrentSlotCodesAsync,
  } = useOrderingPeriod()
  const {
    commerceChannels,
  } = useCommerceChannel()
  const {
    orderMethod,
    // store: orderMethodStore,
  } = useOrderMethod()
  const {
    commerceChannel: orderMethodCommerceChannel,
    menuFilters: orderMethodMenuFilters,
    menuNotFilters: orderMethodMenuNotFilters,
    useMenuCodeFilter: orderMethodMenuCodeFilter,
    useSubmenuCodeFilter: orderMethodSubmenuCodeFilter,
  } = orderMethodMandatory ? orderMethod : {}
  const commerceChannel = _.get(props, 'commerceChannel')
    || orderMethodCommerceChannel
    || _.get(env, 'config.api.commerceChannel')
  const {
    fetchStoreDateTimeInformation,
    stores,
  } = useStores()
  const { metaDefinitions } = useMetaDefinitions()
  const currentSlotCode = useCurrentOrderingPeriod()

  const commerceChannelPublicConfigSchemaVersion = _.get(site, 'siteMetadata.commerceChannelPublicConfigSchemaVersion')
  const commerceChannelConfig = _.get(commerceChannels, `${commerceChannel}.publicConfig.${commerceChannelPublicConfigSchemaVersion}`, {})
  const {
    code: cartInventoryStoreCode,
    id: cartInventoryStoreId,
  } = _.get(cart, 'cartShipments.0.inventoryStore', {})
  const dineInPhysicalStore = _.find(stores, { id: _.get(cart, 'physicalStoreId') })
  const storeCode = _.get(dineInPhysicalStore, 'code', cartInventoryStoreCode)
  const store = _.find(stores, { code: storeCode })

  // PRIVATE METHODS
  function getMenuFilters({ commerceChannelConfig: config }) {
    const commerceChannelConfigMenuFilters = _.get(config, 'menuFilters')
    const commerceChannelConfigMenuNotFilters = _.get(config, 'menuNotFilters')
    const commerceChannelConfigMenuCodeFilter = _.get(config, 'useMenuCodeFilter')
    const commerceChannelConfigSubmenuCodeFilter = _.get(config, 'useSubmenuCodeFilter')

    const menuFilters = orderMethodMenuFilters || commerceChannelConfigMenuFilters || []
    const menuNotFilters = orderMethodMenuNotFilters || commerceChannelConfigMenuNotFilters || []
    // if key exists whether true/false we should use that as priority
    let useMenuCodeFilter = false
    if (_.has(config, 'useMenuCodeFilter')) {
      useMenuCodeFilter = commerceChannelConfigMenuCodeFilter
    }
    if (_.has(orderMethod, 'useMenuCodeFilter')) {
      useMenuCodeFilter = orderMethodMenuCodeFilter
    }
    let useSubmenuCodeFilter = false
    if (_.has(config, 'useSubmenuCodeFilter')) {
      useSubmenuCodeFilter = commerceChannelConfigSubmenuCodeFilter
    }
    if (_.has(orderMethod, 'useSubmenuCodeFilter')) {
      useSubmenuCodeFilter = orderMethodSubmenuCodeFilter
    }

    const parseKey = (key) => {
      switch (_.camelCase(key)) {
        case 'store':
          return 'storeCode'
        case 'commerceChannel':
          return 'commerceChannelCode'
        case 'timeSlot':
        case 'timeslot':
          return 'timeslotCode'
        case 'date':
          return 'today'
        default:
          return key
      }
    }

    return {
      menuFilters: _.map(menuFilters, parseKey),
      menuNotFilters: _.map(menuNotFilters, parseKey),
      useMenuCodeFilter,
      useSubmenuCodeFilter,
    }
  }

  const isSoldOut = (sku) => {
    if (!_.has(sku, 'stockLevel')) return false
    return (
      _.get(sku, 'notAllowedToCheckout', false)
      || _.isNumber(_.get(sku, 'stockLevel', null)) ? _.get(sku, 'stockLevel', 0) === 0 : false
    )
  }

  const validateSku = ({
    sku,
    storeMenuCodes = [],
    storeSubmenuOrderPeriods,
    exclusions = {},
    storeCode: _storeCode = storeCode,
  }) => {
    const supportMenuFilters = !_.isEmpty(
      _.find(metaDefinitions, {
        metaModelName: 'sku',
        fieldKey: 'menu_filter',
      }),
    )
    const supportMenuNotFilters = !_.isEmpty(
      _.find(metaDefinitions, {
        metaModelName: 'sku',
        fieldKey: 'menu_not_filter',
      }),
    )
    const {
      // an array of strings where sku is available.
      // i.e. "Sunday" means sku is available if dayOfWeek is Sunday
      menuFilter = [],
      // an array of strings where sku is NOT avialble.
      // i.e. "Sunday" means sku is NOT available if dayOfWeek is Sunday
      menuNotFilter = [],
      // an array of strings where sku is available (match determined by api).
      // i.e. any strings that match with those in `storeMenuCodes` means the sku is available.
      menuCodeFilter = [],
      submenuCodeFilter = [],
    } = _.get(sku, 'meta', {})

    const dayOfWeek = moment().format('dddd')

    // if any values in storeMenuCodes matches those in menuCodeFilter then
    // set isMenuCodeFilter to true
    let isMenuCodeFilter = false
    let isSubmenuCodeFilter = false
    const useMenuCodeFilter = _.get(getMenuFilters({ commerceChannelConfig }), 'useMenuCodeFilter', false)
    const useSubmenuCodeFilter = _.get(getMenuFilters({ commerceChannelConfig }), 'useSubmenuCodeFilter', false)
    if (useMenuCodeFilter) {
      _.forEach(storeMenuCodes, (code) => {
        if (_.indexOf(menuCodeFilter, code) !== -1) {
          // menuCode match found
          isMenuCodeFilter = true
          // skip dayOfWeek checking when there is menuCodeFilter checking
          exclusions = {
            ...exclusions,
            dayOfWeek: true,
          }
          return // exit forEach loop
        }
      })
    }
    if (
      // if storeMenuCodes is empty then skip menuCodeFilter checking
      _.isEmpty(storeMenuCodes)
      // skip menuCodeFilter checking if useMenuCodes is false
      || !useMenuCodeFilter
    ) {
      isMenuCodeFilter = true
    }

    const storeSubmenuCodes = getCurrentSlotCodes({ submenuOrderPeriods: storeSubmenuOrderPeriods })
    if (useSubmenuCodeFilter) {
      _.forEach(storeSubmenuCodes, (code) => {
        if (_.indexOf(submenuCodeFilter, code) !== -1) {
          // menuCode match found
          isSubmenuCodeFilter = true
          return // exit forEach loop
        }
      })
    }
    if (
      // if storeSubmenuCodes is empty then skip menuCodeFilter checking
      _.isEmpty(storeSubmenuCodes)
      // skip menuCodeFilter checking if useMenuCodes is false
      || !useSubmenuCodeFilter
    ) {
      isSubmenuCodeFilter = true
    }

    // check store open time slot
    const todayOpenTimeSlots = _.get(store, 'todayOpenTimeSlots', [])
    const disableTakeAwayOrdering = _.get(store, 'meta.disableTakeAwayOrdering', false)
    const isWithinOpenTimeSlots = !_.isEmpty(
      _.find(todayOpenTimeSlots, ({ start, end }) => moment().isBetween(start, end)),
    // Empty time slot means store always available e.g. warehouse
    ) || _.isEmpty(todayOpenTimeSlots)

    const valueToCompare = (key) => {
      // To support multi-factor key. e.g. `store|timeSlot`
      if (_.includes(key, '|')) {
        return _.join(
          _.map(
            _.split(key, '|'),
            valueToCompare,
          ),
          '|',
        )
      }
      switch (key) {
        case 'commerceChannel':
          return commerceChannel
        case 'store':
          return _storeCode
        case 'timeSlot':
          return currentSlotCode
        case 'dayOfWeek':
          return dayOfWeek
        default:
          return key
      }
    }
    // whitelist filters - an array of strings that represent the current state of the users
    // demographics: commerceChannel, store, timeslot, and dayOfWeek
    const whitelist = [
      'commerceChannel',
      'store',
      'timeSlot',
      'dayOfWeek',
    ]
    // blacklist filters - an array of strings that represent the current state of the users
    // demographics: whitelistFilters + store|timeslot and store|dayofweek
    const blacklist = [
      ...whitelist,
      'store|timeSlot',
      'store|dayOfWeek',
      'store|dayOfWeek|timeSlot',
      'dayOfWeek|timeSlot',
    ]
    const isFilterKeyExcluded = (key) => (
      _.some(
        _.split(key, '|'),
        (_key) => _.get(exclusions, _key, false),
      )
    )
    const menuFilterResult = (
      _.transform(whitelist, (result, key) => {
        _.set(
          result,
          _.camelCase(`menuFilter_${key}`),
          (
            isFilterKeyExcluded(key)
            || !supportMenuFilters
            || !_.isEmpty(_.intersection(menuFilter, _.castArray(valueToCompare(key))))
          ),
        )
      }, {})
    )
    const menuNotFilterResult = (
      _.transform(blacklist, (result, key) => {
        _.set(
          result,
          _.camelCase(`menuNotFilter_${key}`),
          (
            isFilterKeyExcluded(key)
            || !supportMenuNotFilters
            || _.isEmpty(_.intersection(menuNotFilter, _.castArray(valueToCompare(key))))
          ),
        )
      }, {})
    )

    const validateResult = {
      stockLevel: (!isSoldOut(sku) || _.get(exclusions, 'stockLevel', false)),
      storeOpeningHours: (isWithinOpenTimeSlots || _.get(exclusions, 'storeOpeningHours', false)),
      storeSettings: !disableTakeAwayOrdering,
      menuCodeFilter: isMenuCodeFilter || _.get(exclusions, 'menuCodeFilter', false),
      submenuCodeFilter: isSubmenuCodeFilter || _.get(exclusions, 'submenuCodeFilter', false),
      ...menuFilterResult,
      ...menuNotFilterResult,
    }
    const invalidResult = _.omitBy(validateResult)
    if (!_.isEmpty(invalidResult)) {
      console.log(`////////////////////////\n//////// CheckoutService.validateSku() ////////\n//////// ${_.get(sku, 'code')} ////////\n//////// ${_.join(_.keys(invalidResult), ', ')} ////////\n////////////////////////`)
    }
    return validateResult
  }

  const validateSkuAsync = async ({ storeId, ...options }) => {
    if (_.isNil(storeId)) return validateSku(options)
    try {
      const { dateTimeInformation } = await fetchStoreDateTimeInformation({
        id: storeId,
        date: moment().format('YYYY-MM-DD'),
      })
      const storeMenuCodes = _.get(dateTimeInformation, 'menuCodes', [])
      return validateSku({ storeMenuCodes, ...options })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  const isAllowToCheckout = (options) => (
    _.isEmpty(
      _.omitBy(validateSku(options)),
    )
  )

  const isAllowToCheckoutAsync = async (options) => {
    try {
      const result = await validateSkuAsync(options)
      return _.isEmpty(
        _.omitBy(result),
      )
    } catch (error) {
      return Promise.reject(error)
    }
  }

  // check an array of skus to determine if all are allowed to checkout
  // true - all are available for checkout
  // false - 1 or more is not allowed to checkout
  const isAllowToCheckoutAll = ({ skus, ...others }) => {
    const checklist = _.map(skus, (sku) => isAllowToCheckout({ sku, ...others }))
    // return true if all checklist items are true
    return checklist.every((v) => v === true)
  }

  const isAllowToCheckoutAllAsync = async (options = {}) => {
    const { storeId, skus = [], ...others } = options
    if (_.isNil(storeId)) return isAllowToCheckoutAll(options)
    try {
      const { dateTimeInformation } = await fetchStoreDateTimeInformation({
        id: storeId,
        date: moment().format('YYYY-MM-DD'),
      })
      const storeMenuCodes = _.get(dateTimeInformation, 'menuCodes', [])
      const submenuOrderPeriods = _.get(dateTimeInformation, 'submenuOrderPeriods')
      const checklist = _.map(
        skus,
        (sku) => isAllowToCheckout({
          sku,
          storeMenuCodes,
          submenuOrderPeriods,
          ...others,
        }),
      )
      return checklist.every((v) => v === true)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  function getMetaMenuFilterParams(options = {}) {
    const {
      prefix,
      storeCode: storeCodeOverride = storeCode,
    } = options

    const isMenuFilterSupported = !_.isEmpty(
      _.find(metaDefinitions, { metaModelName: 'sku', fieldKey: 'menu_filter' }),
    )
    const isMenuNotFilterSupported = !_.isEmpty(
      _.find(metaDefinitions, { metaModelName: 'sku', fieldKey: 'menu_not_filter' }),
    )

    // Exit if no menu filter support
    if (!isMenuFilterSupported && !isMenuNotFilterSupported) return {}

    const menuFilters = _.get(getMenuFilters({ commerceChannelConfig }), 'menuFilters', [])
    const menuNotFilters = _.get(getMenuFilters({ commerceChannelConfig }), 'menuNotFilters', [])

    const parseMenuFilterValue = (key) => {
      switch (_.camelCase(key)) {
        case 'storeCode':
          return storeCodeOverride
        case 'dayOfWeek':
          return moment().format('dddd')
        case 'commerceChannelCode':
          return commerceChannel
        case 'timeslotCode':
          return currentSlotCode
        case 'today':
          return moment().format('YYYYMMDD')
        default:
          return key
      }
    }
    const menuFiltersParam = {
      [_.join(_.compact([prefix, 'meta_menu_filter_exist_all']), '|')]: _.compact(_.map(menuFilters, parseMenuFilterValue)),
    }
    const menuNotFiltersParam = {
      [_.join(_.compact([prefix, 'meta_menu_not_filter_not_exist_any']), '|')]: _.compact(_.map(menuNotFilters, parseMenuFilterValue)),
    }
    return {
      ...(isMenuFilterSupported ? menuFiltersParam : {}),
      ...(isMenuNotFilterSupported ? menuNotFiltersParam : {}),
    }
  }

  async function getMetaMenuCodeFilterParamsAsync(options = {}) {
    const {
      prefix,
      storeId: storeIdOverride,
    } = options
    const storeId = storeIdOverride || cartInventoryStoreId
    const isMenuCodeFilterSupported = !_.isEmpty(
      _.find(
        metaDefinitions,
        {
          metaModelName: 'sku',
          fieldKey: 'menu_code_filter',
        },
      ),
    )
    const isSubMenuCodeFilterSupported = !_.isEmpty(
      _.find(
        metaDefinitions,
        {
          metaModelName: 'sku',
          fieldKey: 'submenu_code_filter',
        },
      ),
    )

    const useMenuCodeFilter = _.get(getMenuFilters({ commerceChannelConfig }), 'useMenuCodeFilter', false)
    const useSubmenuCodeFilter = _.get(getMenuFilters({ commerceChannelConfig }), 'useSubmenuCodeFilter', false)

    // get store dateTimeInformation before valdation
    const data = await fetchStoreDateTimeInformation({
      id: storeId,
      date: moment().format('YYYY-MM-DD'),
    })

    const storeMenuCodes = _.get(data, 'dateTimeInformation.menuCodes', [])
    const submenuOrderPeriods = _.get(data, 'dateTimeInformation.submenuOrderPeriods')
    const matchedTimeslots = getCurrentSlotCodes({ submenuOrderPeriods })

    const haveMenuCodes = isMenuCodeFilterSupported
      && useMenuCodeFilter
      && !_.isEmpty(storeMenuCodes)
    const haveSubMenuCodes = isSubMenuCodeFilterSupported
      && useSubmenuCodeFilter
      && !_.isEmpty(matchedTimeslots)

    return {
      ...(haveMenuCodes ? { [_.join(_.compact([prefix, 'meta_menu_code_filter_exist_any']), '|')]: storeMenuCodes } : {}),
      ...(haveSubMenuCodes ? { [_.join(_.compact([prefix, 'meta_submenu_code_filter_exist_any']), '|')]: matchedTimeslots } : {}),
    }
  }

  return {
    getMetaMenuCodeFilterParamsAsync,
    getMetaMenuFilterParams,
    isAllowToCheckout,
    isAllowToCheckoutAsync,
    isAllowToCheckoutAll,
    isAllowToCheckoutAllAsync,
    isSoldOut,
    validateSku,
    validateSkuAsync,
  }
}
